<div class="container-fluid">
    <div class="page-title">
        <div class="row">
            <!-- Select Campaña -->
            <div class="col-6">
                <ol id="selCampaign" class="breadcrumb me-3 mb-0 ms-3">
                    <li class="breadcrumb-item font-blue dropdown drop-container">
                        <mat-spinner class="ms-2" color="accent" diameter="20" *ngIf="isLoadingGeneral; else title"></mat-spinner>
                        <ng-template #title>
                            {{ this.campaignSelected?.name }}
                            <i class="ms-2 arrow down"></i>
                            <div class="drop bg-white">
                                <ul>
                                    <li (click)="setCampaignData(campaign)" 
										class="list-item d-flex align-items-center"
										[ngClass]="{'selected': campaignSelected?.id === campaign.id}"
										*ngFor="let campaign of campaignList">
                                        <span class=" d-flex align-items-center text-truncate" href="#">{{campaign.name}}</span>
										<mat-icon *ngIf="campaignSelected?.id === campaign.id" class="check-icon d-flex align-items-center ms-auto me-2">check</mat-icon>

                                    </li>
                                </ul>
                            </div>
                        </ng-template>
                    </li>
                </ol>
            </div>
            <!-- Info en el header -->
            <div class="col-6 d-flex align-items-right">
                <div class="col-4 text-center">
                    <span class="col-4"><strong class="me-2">Compañía:</strong>  {{this.compania}}</span>
                </div>
                <div class="col-4 text-end">
                    <span class="col-4 me-3"><strong class="me-2">Fecha Inicio:</strong>  {{ this.fecha_inicio ? (this.fecha_inicio | date: 'dd/MM/yyyy') : '' }}</span> 
                </div>
                <div class="col-4 text-end">
                    <span class="col-4 me-3"><strong class="me-2">Fecha Fin:</strong>  {{ this.fecha_fin ? (this.fecha_fin | date: 'dd/MM/yyyy') : '' }}</span>
                </div>
            </div>
        </div>
    </div>

	<div *ngIf="isLoadingGeneral" style="display: flex; justify-content: center; align-items: center; background: white;">
		<mat-progress-bar color="accent" mode="indeterminate">
		</mat-progress-bar>
	</div> 


    <!-- Contendido -->
    <div  class="container-fluid">
        <div class="row ">
            <div class="col-md-12 monitoring-tabs">
                <mat-tab-group mat-stretch-tabs="false" (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="tabActivo">
                    <!-- TAB PROGRESO -->
                    <mat-tab label="Progreso">
                        <div class="row mt-3">
                            <!-- Objetivo General -->
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div class="card">
                                    <div class="card-body" style="padding: 15px !important;">
										<h3 class="h5">Objetivo general</h3>
                                        <div class="container d-flex justify-content-center">
											<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingGeneral" class="row">
                                                <div class="col-lg-8 col-md-12 col-sm-12">
                                                    <div class="row">
                                                        <div class="row col-12 mt-2">

															<div class="col-xl-1 col-lg-1 col-md-2">
																<mat-icon class="align-middle icono-cafe">inventory_2</mat-icon>
															</div>
															<div class="col-xl-5 col-lg-5 col-md-10"> 
																<strong>Total de cajas por encintar</strong>
																<label class="mt-2">{{this.total_cajas}} cajas</label>
															</div>
															<div class="col-xl-1 col-lg-1 col-md-2">
																<mat-icon class="align-middle" color="accent">timer</mat-icon>
															</div>
															<div class="col-xl-5 col-lg-5 col-md-10">
																<strong>Duración de la campaña</strong> 
																<label class="mt-2">{{this.duracion_campana}} dias</label>
															</div>
                                                    	</div>
														<div class="row col-12 mt-3">
															<hr style="border: 1px solid black; width: 100%;">
														</div>
														<div class="row col-12 mt-3">
															<div class="col-md-6 col-sm-12">
																<mat-icon class="align-middle" color="accent" style="position: absolute; z-index: 100; margin-top: 4.1rem; margin-left: 2.4rem;">sports_score</mat-icon>
																<div class="progress-container">
																	<svg class="progress-circle" viewBox="0 0 36 36">
																		<path class="circle-bg"
																				d="M18 2.0845
																				a 15.9155 15.9155 0 0 1 0 31.831
																				a 15.9155 15.9155 0 0 1 0-31.831" />
																		<path class="circle"
																				[attr.stroke-dasharray]="progress + ', 100'"
																				d="M18 2.0845
																				a 15.9155 15.9155 0 0 1 0 31.831
																				a 15.9155 15.9155 0 0 1 0-31.831" />
																				
																		<text [attr.x]="progress === 100 ? 22.5 : 21" y="20.35" class="percentage">     														
																			{{ progress }}% </text>
																	</svg>
																</div>
															</div>
															<div class="col-md-6 col-sm-12 mt-4">
																<strong>Objetivo diario</strong>
																<div *ngIf="this.objetivo_diario > 0">
																	<label class="mt-1">Encintar {{this.objetivo_diario}} cajas durante las siguientes {{this.hr_restantes}} horas</label>
																</div>
																<div *ngIf="this.objetivo_diario == 0">
																	<label class="mt-1">No se encontró un objetivo para la fecha actual</label>
																</div>
															</div>
														</div>
                                                	</div>
                                        		</div>
												<div class="col-lg-4 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
													<img class="img-fluid" src="/assets/images/monitoring/Objetivo-general.jpg" alt="Objetivo general">
												</div>
                                    		</div> 
                                		</div>
                            		</div>
                        		</div>
                    		</div>
                            <!-- Cards (Total sku, bolsas, zonas, picks, materialg, sucursales)-->
                            <div class="col-lg-6 col-md-12 col-sm-12">
                                <div class="row text-center">
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="col-md-12 mt-2">
													<mat-icon class="icono-verde1">inventory</mat-icon>
												</div>
												<div class="col-md-12 mt-3" style="font-size: 16px;">
													<strong>Total SKU</strong>
												</div>
												<label *ngIf="!isLoadingGeneral" class="mt-1" style="font-size: 16px;">{{this.totalSKU}}</label> 
												<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
													<div class="text-center">
														<mat-spinner color="accent" diameter="20" ></mat-spinner>
													</div>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="col-md-12 mt-2">
													<mat-icon class="icono-verde2">shopping_bag</mat-icon>
												</div>
												<div class="col-md-12 mt-3" style="font-size: 16px;">
													<strong>Bolsas</strong>
												</div>
												<label *ngIf="!isLoadingGeneral" class="mt-1" style="font-size: 16px;">{{this.bolsas}}</label>
												<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
													<div class="text-center">
														<mat-spinner color="accent" diameter="20" ></mat-spinner>
													</div>
												</div>                                          
											</div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-body">
												<div class="col-md-12 mt-2">
													<mat-icon class="icono-naranja">map</mat-icon>
												</div>
												<div class="col-md-12 mt-3" style="font-size: 16px;">
													<strong>Zonas</strong>
												</div>
												<label *ngIf="!isLoadingGeneral" class="mt-1" style="font-size: 16px;">{{this.zonas}}</label>
												<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
													<div class="text-center">
														<mat-spinner color="accent" diameter="20" ></mat-spinner>
													</div>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                
                                <div class="row text-center">
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="col-md-12 mt-2">
													<mat-icon class="icono-rojo">barcode_reader</mat-icon>
												</div>
												<div class="col-md-12 mt-3" style="font-size: 16px;">
													<strong>Total de picks</strong>
												</div>
												<label *ngIf="!isLoadingGeneral" class="mt-1" style="font-size: 16px;">{{this.totalPicks}}</label>
												<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
													<div class="text-center">
														<mat-spinner color="accent" diameter="20" ></mat-spinner>
													</div>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-body">
												<div class="col-md-12 mt-2">
													<mat-icon class="icono-amarillo">design_services</mat-icon>
												</div>
												<div class="col-md-12 mt-3" style="font-size: 16px;">
													<strong>Material G</strong>
												</div>
												<label *ngIf="!isLoadingGeneral" class="mt-1" style="font-size: 16px;">{{this.materialG}}</label>
												<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
													<div class="text-center">
														<mat-spinner color="accent" diameter="20" ></mat-spinner>
													</div>
												</div>                                           
											</div>
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="card">
                                            <div class="card-body">
                                                <div class="col-md-12 mt-2">
													<mat-icon class="icono-azul">store</mat-icon>
												</div>
												<div class="col-md-12 mt-3" style="font-size: 16px;">
													<strong>Sucursales</strong>
												</div>
												<label *ngIf="!isLoadingGeneral" class="mt-1" style="font-size: 16px;">{{this.sucursales}}</label>
												<div *ngIf="isLoadingGeneral" class="d-flex justify-content-center align-items-center">
													<div class="text-center">
														<mat-spinner color="accent" diameter="20" ></mat-spinner>
													</div>
												</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
						<!-- Progreso por periodos -->
						<div class="row">
							<div class="col-12 col-md-12">
                                <div class="card">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5">Progreso por periodos</h4>
													<label class="mt-1" *ngIf="periodos.length > 0">Tus periodos se encuentran divididos de la siguiente manera: </label>
												</div>
												<div class="col-md-2 d-flex justify-content-end align-items-center">
													<img style="width: 50px; height: 55px;" src="/assets/images/monitoring/reloj.jpg" alt="Periodos">
												</div>
                                    		</div> 
											<div *ngIf="isLoadingPeriodos" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingPeriodos">
												<div *ngIf="periodos.length > 0">
													<div class="row mt-3">
														<app-progress-bar-periodos [periodos]="periodos" [progress]="progress" [cajas_encintadas]="total_cajas_encintadas" [total_cajas]="total_cajas"></app-progress-bar-periodos>
													</div>
													<div class="row alert alert-warning custom-alert mt-4" role="alert">
														<div *ngIf="progress == 0" class="text-center">
															El camino está por comenzar. ¡Inicia con energía y alcancemos nuestra meta!
														</div>
														<div *ngIf="progress > 0 && progress < 50" class="text-center">
															Determinación y entusiasmo marcan este gran comienzo. No bajemos el ritmo. 
															<br> ¡El éxito será nuestro si perseveramos!
														</div>
														<div *ngIf="progress >= 50 && progress < 100" class="text-center">
															¡El final está cerca! Solo queda un último esfuerzo para llegar al objetivo final. 
															<br> Mantén el ritmo y completa las últimas cajas.
														</div>
														<div *ngIf="progress == 100" class="text-center">
															¡Objetivo alcanzado! Gracias al esfuerzo, dedicación y compromiso de todos  
															<br> se ha logrado una meta más. ¡Felicidades!.
														</div>
													</div>
												</div>
												<div *ngIf="periodos.length == 0" class="text-center">
													<label class="mt-2 mb-2">No se encontraron periodos para la fecha actual</label>
												</div>
											</div>
											
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
						</div>
						<div class="row">
							<!-- Progreso por cajas -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Progreso por cajas<mat-icon class="icono-cafe ms-2">inventory_2</mat-icon>
													</h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingCajas" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingCajas">
												<div *ngIf="progresoxcajas.length == 0" class=" mt-4 d-flex align-items-center justify-content-center">
													<label>No se ha cargado la distribución</label>
												</div>
												<div *ngIf="progresoxcajas.length > 0" class="d-flex align-items-center justify-content-center">
													<apx-chart 
														[series]="chartSeries" 
														[chart]="chartDetails" 
														[labels]="chartLabels"
														[colors]="chartColors"
														[plotOptions]="chartPlotOptions"
														[legend]="chartLegend"
														[responsive]="chartResponsive"
														[dataLabels]="chartDataLabels"
														>
													</apx-chart>
												</div>

												<div *ngIf="progresoxcajas.length > 0" class="mat-elevation-z0 table-responsive text-nowrap table-scroll" id="progressCajas" style="height: 280px">
													<table mat-table [dataSource]="dsCajas" matSort #sort="matSort" class="w-100 small-text-table" id="tableCajas">
														<ng-container matColumnDef="box_id">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
															<td mat-cell *matCellDef="let row"> {{row.box_id}} </td>
														</ng-container>
														<ng-container matColumnDef="id_ext">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> FarmID </th>
															<td mat-cell *matCellDef="let row"> {{ row.id_ext }} </td>
														</ng-container>
														<ng-container matColumnDef="consecutivo">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Consecutivo </th>
															<td mat-cell *matCellDef="let row"> {{row.consecutivo}} </td>
														</ng-container>   
														<ng-container matColumnDef="zona">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Zona </th>
															<td mat-cell *matCellDef="let row"> {{ row.zona}} </td>
														</ng-container>
														<ng-container matColumnDef="status">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Estatus línea </th>
															<td mat-cell *matCellDef="let row"> {{ row.status }} </td>
														</ng-container>
														<ng-container matColumnDef="actions">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Materiales </th>
															<td mat-cell  class="small-icon"  *matCellDef="let row"> 
																<button mat-icon-button matTooltip="Listado de materiales" [matTooltipPosition]="'above'" color="accent" (click)="openDialogMaterialList(row)">
																	<mat-icon>category</mat-icon> 
																</button> 
															</td>
														</ng-container>
					
														<tr mat-header-row *matHeaderRowDef="colsCajas"></tr>
														<tr mat-row *matRowDef="let row; columns: colsCajas;"></tr>
											
														<tr class="mat-row" *matNoDataRow>
															<td class="mat-cell" colspan="6">No se ha cargado la distribución.</td>
														</tr>
													</table>
													<mat-paginator class="custom-paginator" #paginator [pageSizeOptions]="[5]"></mat-paginator>
												</div>
											</div>
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
							<!-- Progreso por archivo -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Progreso por archivo<mat-icon class="icono-azul ms-2">description</mat-icon></h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingArchivo" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingArchivo">
												<div *ngIf="progresoxarchivo.length == 0" class=" mt-4 d-flex align-items-center justify-content-center">
													<label>No se han cargado archivos de guías</label>
												</div>
												<div *ngIf="progresoxarchivo.length > 0" class="d-flex align-items-center justify-content-center">
													<apx-chart 
														[series]="chartSeries2" 
														[chart]="chartDetails2" 
														[labels]="chartLabels2"
														[plotOptions]="chartPlotOptions2"
														[legend]="chartLegend"
														[responsive]="chartResponsive"
														[dataLabels]="chartDataLabels"
														>
													</apx-chart>
												</div>
												<div *ngIf="progresoxarchivo.length > 0" class="mat-elevation-z0 table-responsive text-nowrap table-scroll">
													<table mat-table [dataSource]="dsArchivo" matSort #sortArchivo="matSort" class="w-100 small-text-table" id="tableArch">
														<ng-container matColumnDef="paqueteria">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Paquetería </th>
															<td mat-cell *matCellDef="let row"> {{ row.paqueteria }} </td>
														</ng-container>
														<ng-container matColumnDef="archivo">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre del archivo </th>
															<td mat-cell *matCellDef="let row"> {{ row.nombre }} </td>
														</ng-container>
														<ng-container matColumnDef="estatus_linea">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Estatus línea </th>
															<td mat-cell *matCellDef="let row"> {{row.statusArchivo}} </td>
														</ng-container>
														<ng-container matColumnDef="acciones">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Acciones </th>
															<td mat-cell  class="small-icon"  *matCellDef="let row"> 
																<a href={{row.file}} target="_blank">
																	<button mat-icon-button color="accent">
																		<mat-icon>download</mat-icon>  
																	</button>
																</a>
															</td>	
														</ng-container> 
											
														<tr mat-header-row *matHeaderRowDef="colsArchivo"></tr>
														<tr mat-row *matRowDef="let row; columns: colsArchivo;"></tr>
											
														<tr class="mat-row" *matNoDataRow>
															<td class="mat-cell" colspan="6">No se ha cargado la distribución.</td>
														</tr>
													</table>
													<mat-paginator class="custom-paginator" #paginatorArchivo [pageSizeOptions]="[5]"></mat-paginator>
												</div>
											</div>
											
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
						</div>
						<div class="row">
							<!-- Progreso por paquetería -->
							<div class="col-md-6 col-sm-12">
                                <div class="card cardHeight2">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Progreso por paquetería<mat-icon class="icono-azul ms-2">local_shipping</mat-icon></h4>
												</div>
                                    		</div>

											<div *ngIf="isLoadingPaqueteria" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>

											<div *ngIf="!isLoadingPaqueteria">
												<div *ngIf="progresoxpaqueteria.length == 0" class=" mt-4 d-flex align-items-center justify-content-center">
													<label>No se han cargado los datos de envío</label>
												</div>

												<div *ngFor="let e of progresoxpaqueteria" class="chart row justify-content-between" [ngClass]="{
													'inactive-chart': selectedCarrier && selectedCarrier !== e.carrier
												}" style="cursor: pointer">
												
													<div *ngIf="e.carrier != null" class="row mb-2">
														<div class="col-md-10">
															<div class="col text-end" style="font-size: 12px;">
																<span>{{e.encintados}} de {{e.total}} - </span>
																<span>{{ (e.encintados / e.total) * 100 | number: '1.0-2' }}%</span>
															</div>
															<app-progress-bar-paqueteria [data]="(e.encintados/e.total)*100" [carrier]="e.carrier" (customAction)="filterPaqueteria(e.carrier)" ></app-progress-bar-paqueteria>
														</div>
														<div class="col-md-2">
															<img 
															*ngIf="isImageAvailable(imgFormat(e.carrier))" 
															class="mt-2 img-fluid img-60 progress-chart-image" 
															[src]="'../../../assets/images/carriers/' + imgFormat(e.carrier) + '-sm.jpg'" 
															[alt]="imgFormat(e.carrier)"
															(click)="filterPaqueteria(e.carrier)">
															<span style="font-size: 13px;"
																*ngIf="!isImageAvailable(imgFormat(e.carrier))" 
																class="mt-2 carrier-name"
																(click)="filterPaqueteria(e.carrier)">{{ e.carrier }}
															</span>
														</div>
													</div>

												</div>
												
												<div *ngIf="dsPaqueteria && dsPaqueteria.data && dsPaqueteria.data.length > 0" [hidden]="filterCarrier" class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll">
													<table mat-table [dataSource]="dsPaqueteria" matSort #sortPaqueteria="matSort" class="w-100 small-text-table">
														<ng-container matColumnDef="paqueteria">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Paquetería </th>
															<td mat-cell *matCellDef="let row"> {{ row.paqueteria }} </td>
														</ng-container>
														<ng-container matColumnDef="pendientes">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Pendientes </th>
															<td mat-cell *matCellDef="let row"> {{ row.pendientes }} </td>
														</ng-container>
														<ng-container matColumnDef="en_linea">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> En línea </th>
															<td mat-cell *matCellDef="let row"> {{row.en_linea}} </td>
														</ng-container>
														<ng-container matColumnDef="cerradas">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Cerradas </th>
															<td mat-cell *matCellDef="let row"> {{row.cerradas}} </td>
														</ng-container>
														<ng-container matColumnDef="encintadas">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Encintadas </th>
															<td mat-cell *matCellDef="let row"> {{row.encintadas}} </td>
														</ng-container>
														
														<tr mat-header-row *matHeaderRowDef="colsPaqueteria"></tr>
														<tr mat-row *matRowDef="let row; columns: colsPaqueteria;"></tr>
											
														<tr class="mat-row" *matNoDataRow>
															<td class="mat-cell" colspan="6">No se ha cargado los datos de envío.</td>
														</tr>
													</table>
													<mat-paginator class="custom-paginator" #paginatorPaqueteria [pageSizeOptions]="[5]"></mat-paginator>
												</div>
												<!-- Tabla cuando filtra por paqueteria -->
												<div [hidden]="!filterCarrier" class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll">
													<table mat-table [dataSource]="dsPaqueteriaFiltro" matSort #sortPaqueteriaFiltro="matSort" class="w-100 small-text-table" id="tablePaq">
														<ng-container matColumnDef="box_id">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
															<td mat-cell *matCellDef="let row"> {{row.box_id}} </td>
														</ng-container>
														<ng-container matColumnDef="id_ext">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> FarmID </th>
															<td mat-cell *matCellDef="let row"> {{ row.id_ext }} </td>
														</ng-container>
														<ng-container matColumnDef="consecutivo">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Consecutivo </th>
															<td mat-cell *matCellDef="let row"> {{row.consecutivo}} </td>
														</ng-container>   
														<ng-container matColumnDef="zona">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Zona </th>
															<td mat-cell *matCellDef="let row"> {{ row.zona}} </td>
														</ng-container>
														<ng-container matColumnDef="status">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Estatus línea </th>
															<td mat-cell *matCellDef="let row"> {{ row.status }} </td>
														</ng-container>
														<ng-container matColumnDef="actions">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Materiales </th>
															<td mat-cell  class="small-icon"  *matCellDef="let row"> 
																<button mat-icon-button matTooltip="Listado de materiales" [matTooltipPosition]="'above'" color="accent" (click)="openDialogMaterialList(row)">
																	<mat-icon>category</mat-icon> 
																</button> 
															</td>
														</ng-container>
														
														<tr mat-header-row *matHeaderRowDef="colsPaqueteriaFiltro"></tr>
														<tr mat-row *matRowDef="let row; columns: colsPaqueteriaFiltro;"></tr>
											
														<tr class="mat-row" *matNoDataRow>
															<td class="mat-cell" colspan="6">No se ha cargado la distribución.</td>
														</tr>
													</table>
													<mat-paginator class="custom-paginator" #paginatorPaqueteriaFiltro [pageSizeOptions]="[5]"></mat-paginator>
												</div>
											</div>
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
							<!-- Progreso por tamaños -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight2">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Progreso por tamaños<mat-icon class="icono-cafe ms-2">pallet</mat-icon></h4>
												</div>
                                    		</div>

											<div *ngIf="isLoadingTamanos" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>

											<div *ngIf="!isLoadingTamanos">
												<div *ngIf="progresoxtamanos.length == 0" class=" mt-4 d-flex align-items-center justify-content-center">
													<label>No se han cargado los datos de envío</label>
												</div>

												<div *ngFor="let e of progresoxtamanos" class="chart row justify-content-between"  [ngClass]="{
													'inactive-chart': selectedTamano && selectedTamano !== e.box_size
												}" style="cursor: pointer">
													<div class="row mb-2">
														<div class="col-md-10">
															<div class="col text-end" style="font-size: 12px;">
																<span>{{e.encintados}} de {{e.total}} - </span>
																<span>{{ (e.encintados / e.total) * 100 | number: '1.0-2' }}%</span>
															</div>
															<app-progress-bar-tamanos [data]="(e.encintados/e.total)*100" [box_size]="e.box_size" [isSelected]="e.box_size === selectedTamano" (actionTamanos)="filterTamanos(e.box_size)"></app-progress-bar-tamanos>														
														</div>
														<div class="col-md-2" style="font-size: 13px;">
															<span (click)="filterTamanos(e.box_size)"
																class="mt-2"
																>{{ e.box_size }}
															</span>
														</div>
													</div>
												</div>

												<div *ngIf="progresoxtamanos.length > 0" class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll" id="progressTam" [ngStyle]="{ 'max-height': 600 - (50 * progresoxtamanos.length) + 'px'}">
													<table mat-table [dataSource]="dsTamanos" matSort #sortTamanos="matSort" class="w-100 small-text-table" id="tableTamanos">
														<ng-container matColumnDef="box_id">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
															<td mat-cell *matCellDef="let row"> {{row.box_id}} </td>
														</ng-container>
														<ng-container matColumnDef="id_ext">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> FarmID </th>
															<td mat-cell *matCellDef="let row"> {{ row.id_ext }} </td>
														</ng-container>
														<ng-container matColumnDef="consecutivo">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Consecutivo </th>
															<td mat-cell *matCellDef="let row"> {{row.consecutivo}} </td>
														</ng-container>   
														<ng-container matColumnDef="zona">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Zona </th>
															<td mat-cell *matCellDef="let row"> {{ row.zona}} </td>
														</ng-container>
														<ng-container matColumnDef="status">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Estatus línea </th>
															<td mat-cell *matCellDef="let row"> {{ row.status }} </td>
														</ng-container>
														<ng-container matColumnDef="actions">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Materiales </th>
															<td mat-cell  class="small-icon"  *matCellDef="let row"> 
																<button mat-icon-button matTooltip="Listado de materiales" [matTooltipPosition]="'above'" color="accent" (click)="openDialogMaterialList(row)">
																	<mat-icon>category</mat-icon> 
																</button> 
															</td>
														</ng-container>
														
														<tr mat-header-row *matHeaderRowDef="colsTamanos"></tr>
														<tr mat-row *matRowDef="let row; columns: colsTamanos;"></tr>
											
														<tr class="mat-row" *matNoDataRow>
															<td class="mat-cell" colspan="6">No se ha cargado los datos de envío.</td>
														</tr>
													</table>
													<mat-paginator class="custom-paginator" #paginatorTamanos [pageSizeOptions]="[10]"></mat-paginator>
												</div>
											</div>
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
						</div>
						<div class="row">
							<div class="col-md-12 col-sm-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Recolecciones</h4>
												</div>
                                    		</div>
											<div class="row">
												<label class="mt-1">Este gráfico muestra el historial en tiempo de las cajas recolectadas tras su cierre</label>
											</div>
											<div *ngIf="isLoadingRecolecciones" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingRecolecciones">
												<div class="row mt-4">
													<div class="col-md-3">
														<mat-form-field class="w-100" color="accent">
															<mat-label>Ver por</mat-label>
															<mat-select [(ngModel)]="selectedRec1" (selectionChange)="getRecolecciones()">
																<mat-option value="cajas">Cajas</mat-option>
																<mat-option value="archivo">Por Archivo</mat-option>
																<mat-option value="paqueteria">Por Paquetería</mat-option>
																<mat-option value="tamano">Por Tamaño</mat-option>
															</mat-select>
														</mat-form-field>
													</div>
													<div class="col-md-3">
														<mat-form-field class="w-100" color="accent">
															<mat-label>Ver por</mat-label>
															<mat-select [(ngModel)]="selectedRec2" (selectionChange)="getRecolecciones()">
																<mat-option value="periodos">Periodos</mat-option>
																<mat-option value="cajas_cerradas">Cajas Cerradas</mat-option>
															</mat-select>
														</mat-form-field>
													</div>
												</div>
												<div class="row mt-4 ">
													<div class="col-md-9">
														<div class="row table-scroll" style="height:300px">
															<div class="col-md-4">
																<div class="d-flex align-items-center justify-content-center mb-2">
																	<label>Cerradas</label>
																</div>
																<div *ngFor="let r of recCerradas" class="card d-flex flex-row align-items-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec" [ngStyle]="{ 'border-left': '7px solid ' + r.color }">
																	<div class="flex-grow-1 bodyRecolec">
																	<div class="d-flex justify-content-between align-items-center mb-2">
																		<span class="fw-bold">{{r.nombrePeriodo}} {{r.nombrePeriodo !== '' ? ' - ' : ''}} {{r.dia}}</span>
																	</div>
																	<div class="text-muted">
																		{{r.total_encintadas}} Cajas - {{r.fecha}} - {{r.ultima_encintada}}
																	</div>
																	<div class="text-muted">{{r.tipo}}</div>
																	</div>
																</div>
																<div *ngIf="recCerradas?.length == 0" class="card d-flex flex-row align-items-center text-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec">
																	Sin cajas encintadas
																</div>
															</div>
															<div class="col-md-4">
																<div class="d-flex align-items-center justify-content-center mb-2">
																	<label>Recolectadas</label>
																</div>
																<div *ngFor="let r of recCerradas">
																	<div  *ngIf="r.recolectadas>0" class="card d-flex flex-row align-items-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec" [ngStyle]="{ 'border-left': '7px solid ' + r.color }">
																		<div class="flex-grow-1 bodyRecolec">
																		<div class="d-flex justify-content-between align-items-center mb-2">
																			<span class="fw-bold">{{r.nombrePeriodo}} {{r.nombrePeriodo !== '' ? ' - ' : ''}} {{r.dia}}</span>
																			<div class="d-flex align-items-center">
																				<span class="text-success">A tiempo</span>
																				<a [href]="r.documento" target="_blank"><mat-icon color="accent" class="ms-1 icon-sm">visibility</mat-icon></a>
																			</div>
																		</div>
																		<div class="text-muted">
																			{{r.recolectadas}} Cajas - {{r.fecha}} - {{r.hora_recolectada}}
																		</div>
																		<div class="text-muted">{{r.tipo}}</div>
																		</div>
																	</div>
																</div>
																<div *ngFor="let rt of recCerradasTarde">
																	<div *ngIf="rt.dias_retardo > 0" class="card d-flex flex-row align-items-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec" [ngStyle]="{ 'border-left': '7px solid' + rt.color }">
																		<div class="flex-grow-1 bodyRecolec">
																		<div class="d-flex justify-content-between align-items-center mb-2">
																			<span class="fw-bold">{{rt.nombrePeriodo}} {{rt.nombrePeriodo !== '' ? ' - ' : ''}} {{rt.dia}}</span>
																			<div class="d-flex align-items-center">
																				<span class="text-danger">Retardo {{rt.dias_retardo}} días</span>
																				<a [href]="rt.documento" target="_blank"><mat-icon color="accent" class="ms-1 icon-sm">visibility</mat-icon></a>
																			</div>
																		</div>
																		<div class="text-muted">
																			{{rt.recolectadas}} Cajas - {{rt.fecha}} - {{rt.hora_recolectada}}
																		</div>
																		<div class="text-muted">{{rt.tipo}}</div>
																		</div>
																	</div>
																</div>
																<div *ngIf="recCerradas?.length == 0 && recCerradasTarde?.length == 0" class="card d-flex flex-row align-items-center text-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec">
																	Sin cajas recolectadas
																</div>
																
			
															</div>
															<div class="col-md-4">
																<div class="d-flex align-items-center justify-content-center mb-2">
																	<label>Pendientes</label>
																</div>
																<div *ngFor="let r of recPendientes">
																	<div *ngIf="r.total_encintadas > r.recolectadas" class="card d-flex flex-row align-items-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec" [ngStyle]="{ 'border-left': '7px solid ' + r.color }">
																		<div class="flex-grow-1 bodyRecolec">
																		<div class="d-flex justify-content-between align-items-center mb-2">
																			<span class="fw-bold">{{r.nombrePeriodo}} {{r.nombrePeriodo !== '' ? ' - ' : ''}} {{r.dia}}</span>
																		</div>
																		<div class="text-muted">
																			{{r.pendientes}} - {{r.fecha}} - {{r.hora_pendientes}}
																		</div>
																		<div class="text-muted">{{r.tipo}}</div>
																		</div>
																	</div>
																</div>
																<div *ngFor="let r of recCerradas">
																	<div class="card d-flex flex-row align-items-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec" [ngStyle]="{ 'border-left': '7px solid ' + r.color }">
																		<div class="flex-grow-1 bodyRecolec">
																		<div class="d-flex justify-content-between align-items-center mb-2">
																			<span class="fw-bold">{{r.nombrePeriodo}} {{r.nombrePeriodo !== '' ? ' - ' : ''}} {{r.dia}}</span>
																		</div>
																		<div class="text-muted">
																			{{r.pendientes}} - {{r.fecha}} - {{r.hora_pendientes}}
																		</div>
																		<div class="text-muted">{{r.tipo}}</div>
																		</div>
																	</div>
																</div>
																<div *ngIf="recCerradas?.length == 0 && recPendientes.length == 0" class="card d-flex flex-row align-items-center text-center shadow-sm p-2 mb-3 me-2 ms-2 cardRecolec">
																	Sin cajas pendientes
																</div>
																
															</div>
														</div>
													</div>
													<div class="col-md-3 d-flex justify-content-center align-items-center">
														<img class="img-fluid" src="/assets/images/monitoring/Recolecciones.jpg" alt="Recolecciones">
													</div>
												</div>
											</div>
											
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<!-- Cajas procesadas por linea -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Cajas procesadas por línea</h4>
												</div>
                                    		</div>
											<div class="row">
												<label class="mt-1">Progreso en tiempo real</label>
											</div> 
											<div *ngIf="isLoadingCajasProcesadas" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingCajasProcesadas">
												<div *ngFor="let b of boxesProcesadasLinea" class="row mt-3">
													<div *ngIf="b?.porcentaje !== undefined">
														<app-progress-bar-cajas-x-linea [progress]="b.porcentaje" [cajas_x_linea]="b.cajas_x_linea" [cajas_encintadas]="b.cajas_encintadas" [promedio]="b.promedio_empaque" [color1]="b.color1" [color2]="b.color2" [linea]="b.line"></app-progress-bar-cajas-x-linea>
													</div>
												</div>
												<div *ngIf="boxesProcesadasLinea.length == 0" class="text-center">
													<label class="mt-5">No se encontró información para el día actual</label>
												</div>
											</div>
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
							<!-- Cumplimiento de objetivos durante la campaña -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Cumplimiento de objetivos durante la campaña</h4>
												</div>
                                    		</div>
											<div class="row">
												<label class="mt-1">Consulta si los objetivos se cumplieron en cada periodo definido</label>
											</div>
											<div *ngIf="isLoadingCumplimiento" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingCumplimiento" class="container mt-4">
												<div class="d-flex justify-content-end mb-3">
												  <span class="me-3"><span class="legend-box green-bg" ></span> Cumplido</span>
												  <span><span class="legend-box red-bg" ></span> No cumplido</span>
												</div>

												<div *ngFor="let dia of objetivosCampaign; let i = index" class="mb-3">
													<h6>Día {{ i + 1 }}</h6>
													<div class="row">
													  <ng-container *ngFor="let cump of periodosCampaign">
														<div *ngIf="dia.fecha == cump.fechaObjetivo" class="col-md-4 px-1 mb-1">
														  <div class="progress mb-1" style="height: 13px; border-radius: 8px;">
															<div 
															  class="progress-bar" 
															  [ngClass]="{'green-bg': cump.total_encintadas === cump.cajas && cump.total_encintadas > 0,
																'red-bg': cump.total_encintadas != cump.cajas
															  }"
															  role="progressbar" 
															  style="width: 100%;" 
															  aria-valuenow="100" 
															  aria-valuemin="0" 
															  aria-valuemax="100">
															</div>
														  </div>
														  <div class="text-center small">Progreso: {{cump.total_encintadas}}/{{cump.cajas}}</div>
														</div>
													  </ng-container>
													  <div *ngIf="periodosCampaign.length == 0">
														<label>No se encontraron periodos para este día</label>
													  </div>
													</div>
												</div>

												<div class="mb-4">
													<h6>Pendientes</h6>
													<div class="row">
														<div class="col-md-12 px-1">
															<div class="progress mb-1" style="height: 13px; border-radius: 8px;">
															  <div 
																class="progress-bar"
																[ngClass]="encintadas >= total_cajas ? 'green-bg' : 'red-bg'"
																role="progressbar" 
																[style.width.%]="(encintadas / total_cajas) * 100" 
																[attr.aria-valuenow]="(encintadas / total_cajas) * 100"
																aria-valuemin="0" 
																aria-valuemax="100">
															  </div>
															</div>
															<div class="text-center small">Progreso: {{encintadas}}/{{total_cajas}}</div>
														  </div>
													</div>
												</div>
											  
											</div>
                                		</div>
                            		</div>
                        		</div>
                    		</div>
						</div>
						<div class="row">
							<!-- Defectos detectados por calidad -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight2">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Defectos detectados por calidad</h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingDefectos" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>

											<div *ngIf="!isLoadingDefectos">
												<div *ngIf="defectosCalidad.length == 0" class=" mt-4 d-flex align-items-center justify-content-center">
													<label>No hay defectos detectados</label>
												</div>

												<div *ngFor="let e of defectosCalidad" class="chart row justify-content-between"  [ngClass]="{
													'inactive-chart': selectedDefecto && selectedDefecto !== e.tipo_error
												}" style="cursor: pointer">
													<div class="row mb-2">
														<div class="col-md-10">
															<div class="col text-end" style="font-size: 12px;">
																<span>{{ (e.boxes / total_cajas) * 100 | number: '1.0-2' }}%</span>
															</div>
															<app-progress-bar-calidad [data]="(e.boxes/total_cajas)*100" [tipo_error]="e.tipo_error" [isSelected]="e.tipo_error === selectedDefecto" (actionCalidad)="filterCalidad(e.tipo_error)"></app-progress-bar-calidad>														
														</div>
														<div class="col-md-2" style="font-size: 13px;">
															<span (click)="filterCalidad(e.tipo_error)"
																class="mt-2"
																>{{ e.tipo_error_label }}
															</span>
														</div>
													</div>
												</div>

												<div *ngIf="defectosCalidad.length > 0" class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll-calidad" id="progressCal">
													<table mat-table [dataSource]="dsDefectos" matSort #sortDefectos="matSort" class="w-100 small-text-table" id="tableCal">
														<ng-container matColumnDef="box_id">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> ID </th>
															<td mat-cell *matCellDef="let row"> {{row.box_id}} </td>
														</ng-container>
														<ng-container matColumnDef="id_ext">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> FarmID </th>
															<td mat-cell *matCellDef="let row"> {{ row.id_ext }} </td>
														</ng-container>
														<ng-container matColumnDef="consecutivo">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Consecutivo </th>
															<td mat-cell *matCellDef="let row"> {{row.consecutivo}} </td>
														</ng-container>   
														<ng-container matColumnDef="estacion">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Estación </th>
															<td mat-cell *matCellDef="let row"> {{ row.estacion}} </td>
														</ng-container>
														<ng-container matColumnDef="nombre">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre </th>
															<td mat-cell *matCellDef="let row"> {{ row.nombre }} </td>
														</ng-container>
														<ng-container matColumnDef="cantidad">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Cantidad </th>
															<td mat-cell *matCellDef="let row"> {{ row.cantidad }} </td>
														</ng-container>
														<ng-container matColumnDef="tipo_error">
															<th mat-header-cell *matHeaderCellDef mat-sort-header> Defecto </th>
															<td mat-cell *matCellDef="let row"> {{ row.tipo_error }} </td>
														</ng-container>
														
														
														<tr mat-header-row *matHeaderRowDef="colsDefectos"></tr>
														<tr mat-row *matRowDef="let row; columns: colsDefectos;"></tr>
											
														<tr class="mat-row" *matNoDataRow>
															<td class="mat-cell" colspan="7">No se han detectado defectos en calidad.</td>
														</tr>
													</table>
													<mat-paginator class="custom-paginator" #paginatorDefectos [pageSizeOptions]="[10]"></mat-paginator>
												</div>
											</div>
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
							<!-- Cajas rechazadas por el semaforo -->
							<div class="col-md-6 col-sm-12 col-xs-12">
                                <div class="card cardHeight2" >
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Cajas rechazadas por el semáforo</h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingCajasRechazadas" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div  *ngIf="!isLoadingCajasRechazadas" class="row mt-4">
												<!-- <div class="col-sm-6 col-md-5">
													<mat-form-field class="w-100" color="accent">
														<mat-label>Ver por</mat-label>
														<mat-select>
															<mat-option value="cajas">Cajas</mat-option>
															<mat-option value="archivo">Por Archivo</mat-option>
															<mat-option value="paqueteria">Por Paquetería</mat-option>
															<mat-option value="tamano">Por Tamaño</mat-option>
														</mat-select>
													</mat-form-field>
												</div> -->
												<div class="cols-sm-6 col-md-5">
													<mat-form-field class="w-100" color="accent">
														<mat-label>Fecha</mat-label>
														<input matInput [matDatepicker]="pickerFecha" [(ngModel)]="fechaActual" (dateChange)="getCajasRechazadas()">
														<mat-datepicker-toggle matSuffix [for]="pickerFecha"></mat-datepicker-toggle>
														<mat-datepicker #pickerFecha></mat-datepicker>
													</mat-form-field>
												</div>
											</div>
											<div  *ngIf="!isLoadingCajasRechazadas" class="row mt-4 scroll-rechazadas mx-0">
												<div class="progress-wrapper">
													<div *ngFor="let progress of progressList" class="px-8" >
														<div class="d-flex justify-content-center align-items-center">
															<label class="mb-2 fw-bold">{{progress.periodo}}</label>
														</div>
														<div class="d-flex justify-content-center align-items-center">
															<div class="progress-container-semaforo " >
																<svg class="progress-circle" viewBox="0 0 36 36">
																	<path class="circle-bg-sem" [style.stroke]="progress.color2"
																			d="M18 2.0845
																			a 15.9155 15.9155 0 0 1 0 31.831
																			a 15.9155 15.9155 0 0 1 0-31.831" />
																	<path class="circle-sem" [style.stroke]="progress.color"
																			[attr.stroke-dasharray]="progress.porcentaje + ', 100'"
																			d="M18 2.0845
																			a 15.9155 15.9155 0 0 1 0 31.831
																			a 15.9155 15.9155 0 0 1 0-31.831" />
																			
																	<text [attr.x]="progress.porcentaje === 100 ? 18 : 19" y="20.35" class="percentage">{{ progress.porcentaje }}%</text>
																</svg>
															</div>
														</div>

														<div class="row mt-5" [style.border-bottom]="'2px solid ' + progress.color">
															<div class="col-md-6">
																<label>Total de cajas</label>
															</div>
															<div class="col-md-6 text-end">
																<label class="fw-bold" [style.color]="progress.color">{{progress.cajas}}</label>
															</div>
														</div>

														<div class="row mt-3" [style.border-bottom]="'2px solid ' + progress.color">
															<div class="col-md-6">
																<label>Cajas rechazadas</label>
															</div>
															<div class="col-md-6 text-end">
																<label class="fw-bold" [style.color]="progress.color">{{progress.cajas_rechazadas}}</label>
															</div>
														</div>

													</div>
													<div *ngIf="progressList.length == 0" class="text-center">
														<label class="mt-2 mb-2">No se encontraron registros en esta fecha</label>
													</div>
												</div>
												
											</div>
											
                                		</div>
                            		</div>
                        		</div>
                    		</div>
						</div>
                    </mat-tab>
                    
                    <!-- TAB COMPARATIVAS Y RANKING -->
                    <mat-tab *ngIf="mostrarTab" label="Comparativas y ranking" >
						<!-- Comparativa de picks por estacion -->
                        <div class="row mt-3">
							<div class="col-md-12 col-sm-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Comparativa de picks por estación</h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingPicksStation" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingPicksStation"  class="row">
												<div class="col-md-11">
													<label class="mt-1">Selecciona dos estaciones para iniciar la comparación en el gráfico lateral, mostrando la diferencia entre el tiempo esperado vs real</label>
												</div>
												<div class="col-md-1 text-end">
													<button color="primary" mat-icon-button matTooltip="Filtros" [matMenuTriggerFor]="filters">
            											<mat-icon>tune</mat-icon>
          											</button>
													<mat-menu #filters="matMenu">
														<button mat-menu-item (click)="updateChartData(1)" [ngClass]="{'selected': 1 === selectedCajaPick}">
															<span class="d-flex align-items-center w-100">
																<span class="text-truncate me-4" [ngClass]="{'text-green': 1 === selectedCajaPick}">Caja y Pick</span>
																<mat-icon *ngIf="1 === selectedCajaPick" class="check-icon ms-auto me-1 d-flex align-items-center">check</mat-icon>
															</span>
														</button>
														<button mat-menu-item (click)="updateChartData(2)" [ngClass]="{'selected': 2 === selectedCajaPick}">
															<span class="d-flex align-items-center w-100">
																<span class="text-truncate me-5" [ngClass]="{'text-green': 2 === selectedCajaPick}">Caja</span>
																<mat-icon *ngIf="2 === selectedCajaPick" class="check-icon ms-auto me-1 d-flex align-items-center">check</mat-icon>
															</span>
														</button>
														<button mat-menu-item (click)="updateChartData(3)" [ngClass]="{'selected': 3 === selectedCajaPick}">
															<span class="d-flex align-items-center w-100">
																<span class="text-truncate me-5" [ngClass]="{'text-green': 3 === selectedCajaPick}">Pick</span>
																<mat-icon *ngIf="3 === selectedCajaPick" class="check-icon ms-auto d-flex align-items-center">check</mat-icon>
															</span>
														</button>
													</mat-menu>
												</div>
												
											</div>

											<div *ngIf="!isLoadingPicksStation" class="row mt-3" style="min-height: 300px !important">
												<div class="col-md-8">
													<div *ngIf="periodosCampaign.length > 0" class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll">
														<table mat-table [dataSource]="dsPicksEstacion" matSort #sortPicksEstacion="matSort" class="w-100 medium-text-table" id="tablePicks">
															<ng-container matColumnDef="estacion">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Estación </th>
																<td mat-cell *matCellDef="let row"> {{row.estacion}} </td>
															</ng-container>
															<ng-container matColumnDef="num_picks">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> #Picks </th>
																<td mat-cell *matCellDef="let row"> {{row.num_picks}} </td>
															</ng-container>
															<ng-container matColumnDef="totalSku">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> #SKU's </th>
																<td mat-cell *matCellDef="let row"> {{row.totalSku}} </td>
															</ng-container>   
															<ng-container matColumnDef="incorrects">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Escaneos incorrectos </th>
																<td mat-cell *matCellDef="let row"> {{row.incorrects}} </td>
															</ng-container>
															<ng-container matColumnDef="objTiempoCaja">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Obj. tiempo por caja </th>
																<td mat-cell *matCellDef="let row"> {{row.nameObjTiempoCaja}} </td>
															</ng-container>
															<ng-container matColumnDef="objTiempoPick">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Obj. tiempo por pick </th>
																<td mat-cell *matCellDef="let row"> {{row.nameObjTiempoPick}} </td>
															</ng-container>
															<ng-container matColumnDef="realTiempoCaja">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Tiempo real por caja </th>
																<td mat-cell *matCellDef="let row"><mat-icon class="icono-azul icon-sm me-1">timer</mat-icon>{{row.nameRealTiempoCaja}} </td>
															</ng-container>
															<ng-container matColumnDef="realTiempoPick">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Tiempo real por pick </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-azul icon-sm me-1">timer</mat-icon>{{row.nameRealTiempoPick}} </td>
															</ng-container>
															
															
															<tr mat-header-row *matHeaderRowDef="colsPicksEstacion"></tr>
															<tr mat-row *matRowDef="let row; columns: colsPicksEstacion;" (click)="toggleRowSelection(row)" [class.selected]="isSelected(row)"></tr>
												
															<tr class="mat-row" *matNoDataRow>
																<td class="mat-cell" colspan="8">No se han hecho picks.</td>
															</tr>
														</table>
														<mat-paginator class="custom-paginator" #paginatorPicksEstacion [pageSizeOptions]="[10]"></mat-paginator>
													</div>
													<div *ngIf="periodosCampaign.length == 0" class="text-center">
														<label>No se han cargado periodos para esta campaña</label>
													</div>
												</div>
												<div class="col-md-4">
													<canvas baseChart
													[data]="barChartData"
													[options]="barChartOptions"
													chartType="bar"
													style="height: 400px !important;"
													>
													</canvas>
												</div>
											</div>
											
											
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Ranking de posiciones -->
						<div class="row">
							<div class="col-md-12 col-sm-12">
                                <div class="card cardHeight">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Ranking de posiciones</h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingRanking" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingRanking" class="row mt-3">
												<div class="col-md-12">
													<div class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll">
														<table mat-table [dataSource]="dsRanking" matSort #sortRanking="matSort" class="w-100 medium-text-table" id="tableRanking">
															<ng-container matColumnDef="posicion">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Posición </th>
																<td mat-cell *matCellDef="let row"> <strong>{{row.posicion}}.</strong>  <mat-icon class="icono-gris icon-sm me-1 ms-2">account_circle</mat-icon> {{row.usuario}} </td>
															</ng-container>
															<ng-container matColumnDef="materialesEscaneados">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Materiales escaneados </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-azul icon-sm me-1">category</mat-icon> {{row.materialesEscaneados}}  </td>
															</ng-container>
															<ng-container matColumnDef="tiempo_real_picks">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Tiempo por pick </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-azul icon-sm me-1">timer</mat-icon> {{row.nameRealTiempoPick}} </td>
															</ng-container>   
															<ng-container matColumnDef="scan_errors">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Escaneos incorrectos </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-rojo icon-sm me-1">cancel</mat-icon> {{row.scan_errors}} </td>
															</ng-container>
															<ng-container matColumnDef="errores_calidad">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Errores detectados por calidad </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-rojo icon-sm me-1">person_cancel</mat-icon> {{row.errores_calidad}} </td>
															</ng-container>
															<ng-container matColumnDef="dias_productivos">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Días productivos </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-azul icon-sm me-1">calendar_month</mat-icon> {{row.dias_productivos}} </td>
															</ng-container>
															<ng-container matColumnDef="posiciones">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Desplazamiento </th>
																<td mat-cell *matCellDef="let row">
																	<ng-container *ngIf="row.posicion_anterior - row.posicion !== 0 && row.posicion_anterior != null; else igual">
																		<mat-icon 
																		  class="icon-sm me-1"
																		  [ngClass]="{
																			'icono-verde1': row.posicion_anterior - row.posicion > 0,
																			'icono-rojo': row.posicion_anterior - row.posicion < 0
																		  }">
																		  {{ row.posicion_anterior - row.posicion > 0 ? 'arrow_drop_up' : 'arrow_drop_down' }} 
																		</mat-icon>
																		{{
																			(row.posicion_anterior - row.posicion) < 0
																			  ? (row.posicion_anterior - row.posicion) * -1
																			  : (row.posicion_anterior - row.posicion)
																		}}
																	  </ng-container>
																	  <ng-template #igual>
																		-
																	  </ng-template>
																</td>
															</ng-container>
															<ng-container matColumnDef="puntaje">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Puntaje </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-amarillo2 icon-sm me-1">workspace_premium</mat-icon> {{row.puntaje}} </td>
															</ng-container>
															
															
															<tr mat-header-row *matHeaderRowDef="colsRanking"></tr>
															<tr mat-row *matRowDef="let row; columns: colsRanking;"></tr>
												
															<tr class="mat-row" *matNoDataRow>
																<td class="mat-cell" colspan="8">No se han hecho picks.</td>
															</tr>
														</table>
														<mat-paginator class="custom-paginator" #paginatorRanking [pageSizeOptions]="[10]"></mat-paginator>
													</div>
												</div>
												
											</div>
											
											
										</div>
									</div>
								</div>
							</div>
						</div>
						<!-- Progreso de Calidad -->
						<div class="row">
							<div class="col-md-12 col-sm-12">
                                <div class="card cardHeight3">
                                    <div class="card-body" style="padding: 15px !important;">
                                        <div class="container-fluid">
											<div class="row">
												<div class="col-md-10">
													<h4 class="h5 d-flex">Progreso de calidad</h4>
												</div>
                                    		</div>
											<div *ngIf="isLoadingCalidad" class="d-flex justify-content-center align-items-center">
												<div class="text-center">
													<mat-spinner color="accent" diameter="50" ></mat-spinner>
												</div>
											</div>
											<div *ngIf="!isLoadingCalidad" class="row mt-3">
												<div class="col-md-9">
													<div class="mat-elevation-z0 table-responsive text-nowrap mt-1 table-scroll">
														<table mat-table [dataSource]="dsCalidad" matSort #sortCalidad="matSort" class="w-100 medium-text-table" id="tableCalidad">
															<ng-container matColumnDef="usuario">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Operador </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icon-sm me-1">account_circle</mat-icon> {{row.usuario}} </td>
															</ng-container>
															<ng-container matColumnDef="num_calidad">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> #Calidad </th>
																<td mat-cell *matCellDef="let row"> 1 </td>
															</ng-container>
															<ng-container matColumnDef="totalBoxesByUser">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Total de cajas </th>
																<td mat-cell *matCellDef="let row"> <mat-icon class="icono-cafe icon-sm me-1">inventory_2</mat-icon> {{row.totalBoxesByUser}} </td>
															</ng-container>   
															<ng-container matColumnDef="num_picks">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> #Picks </th>
																<td mat-cell *matCellDef="let row"> {{row.num_picks}} </td>
															</ng-container>
															<ng-container matColumnDef="tiempo_real_cajas">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Tiempo por caja </th>
																<td mat-cell *matCellDef="let row"><mat-icon class="icono-azul icon-sm me-1">timer</mat-icon> {{row.nameRealTiempoCaja}} </td>
															</ng-container>
															<ng-container matColumnDef="tiempo_real_picks">
																<th mat-header-cell *matHeaderCellDef mat-sort-header> Tiempo por pick </th>
																<td mat-cell *matCellDef="let row"><mat-icon class="icono-azul icon-sm me-1">timer</mat-icon> {{ row.nameRealTiempoPick?.includes('NaN') ? '0 m 0 s' : row.nameRealTiempoPick }} </td>
															</ng-container>
															
															<tr mat-header-row *matHeaderRowDef="colsCalidad"></tr>
															<tr mat-row *matRowDef="let row; columns: colsCalidad;"></tr>
												
															<tr class="mat-row" *matNoDataRow>
																<td class="mat-cell" colspan="6">No se han hecho picks.</td>
															</tr>
														</table>
														<mat-paginator class="custom-paginator" #paginatorCalidad [pageSizeOptions]="[10]"></mat-paginator>
													</div>
												</div>
												<div class="col-lg-3 col-md-12 col-sm-12 d-flex justify-content-center align-items-center">
													<img class="img-fluid" src="/assets/images/monitoring/calidad.jpg" alt="progreso de calidad">
												</div>
											</div>
											
											
										</div>
									</div>
								</div>
							</div>
						</div>
                    </mat-tab>
					
					
                </mat-tab-group>
            </div>
        </div>
    </div>
    
</div>
    



